/* 
    *  You have to include the store in each modal because  
    *  ionic decided they didn't need to access it. This 
    *  also won't show up in your Vue Debugger.
*/

import './styles.scss';
import store from '../../store/';

export default {
    name: 'EulaModal',

    store,

    methods: {
        signAgreement() {
            this.$store.commit('setEula', Date.now());
            this.$ionic.modalController.dismiss();
        }
    }
};